export const SwitchColor = '#5bc4bf'
